module.exports = __webpack_public_path__ + "assets/img/mecha-765210db.png";